import { getContacts } from '../../api/profile'
import { phones, emails, addresses } from '../../api/profile'

export default {
    state: {
        contactEmailState: {},
        contactPhoneState: {},
        contactAddressState: {},
    },
    getters: {
        contactEmails: state => state.contactEmailState,
        contactPhones: state => state.contactPhoneState,
        contactAddresses: state => state.contactAddressState,
    },
    mutations: {
        getContactInfo(state, payload) {
            state.contactEmailState = payload.emails
            state.contactPhoneState = payload.phones
            state.contactAddressState = payload.addresses
        },

        saveEmail(state, payload) {
            let stateRef = state.contactEmailState
            if(payload.editId) {
                let record = stateRef.find(item => item.id === payload.editId)
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData)
            }
            else {
                stateRef.push(payload.newData)
            }
        },

        savePhone(state, payload) {
            let stateRef = state.contactPhoneState
            if(payload.editId) {
                let record = stateRef.find(item => item.id === payload.editId)
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData)
            }
            else {
                stateRef.push(payload.newData)
            }
        },

        saveAddress(state, payload) {
            let stateRef = state.contactAddressState
            if (payload.editId) {
                let record = stateRef.find(item => item.id === payload.editId)
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData)
            }
            else {
                stateRef.push(payload.newData)
            }
        }
    },

    actions: {
        getContactInfo({ commit, state, rootGetters }) {
            let entityId = rootGetters['profile/entityId'];
            let profileId = rootGetters['profile/memberId'];

            if (_.isEmpty(state.contactState)) {
                axios.get(getContacts(entityId, profileId))
                    .then(response => {
                        commit('getContactInfo', response.data)
                    })
            }
        },

        saveEmail({ commit, rootGetters }, formData) {
            let entityId = rootGetters['profile/entityId'];
            let profileId = rootGetters['profile/memberId'];
            let requestUrl = emails(entityId, profileId)
            let requestType = 'post'

            if (formData.editId) {
                requestUrl += `/${formData.editId}`
                requestType = 'put'
            }

            const promise = axios[requestType](requestUrl, formData.newData);

            promise.then(
                response => {
                    commit('saveEmail', {
                        editId : formData.editId,
                        newData: response.data.email
                    })
                },
                error => {}
            )

            return promise
        },

        savePhone({ commit, rootGetters }, formData) {
            let entityId = rootGetters['profile/entityId'];
            let profileId = rootGetters['profile/memberId'];
            let requestUrl = phones(entityId, profileId)
            let requestType = 'post'

            if (formData.editId) {
                requestUrl += `/${formData.editId}`
                requestType = 'put'
            }

            const promise = axios[requestType](requestUrl, formData.newData);

            promise.then(
                response => {
                    commit('savePhone', {
                        editId : formData.editId,
                        newData: response.data.phone
                    })
                },
                error => {}
            )

            return promise
        },

        saveAddress({ commit, rootGetters }, formData) {
            let entityId = rootGetters['profile/entityId'];
            let profileId = rootGetters['profile/memberId'];
            let requestUrl = addresses(entityId, profileId)
            let requestType = 'post'

            if (formData.editId) {
                requestUrl += `/${formData.editId}`
                requestType = 'put'
            }

            const promise = axios[requestType](requestUrl, formData.newData);

            promise.then(
                response => {
                    commit('saveAddress', {
                        editId : formData.editId,
                        newData: response.data.address
                    })
                },
                error => {}
            )

            return promise
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/profile/contact.js